import {
  FaEnvelope,
  FaGithub,
  FaLinkedin,
  FaPhoneSquare,
} from "react-icons/fa";
import "./Contact.css";

function Contact() {
  return (
    <section id="contact">
      <nav className="#contact">
        <div className="contact">
          <img src="images/logo_light_name.png" alt="Mossrock B.V." />
          <h2>Contact:</h2> 
          <a href="mailto:mossrockbvconsultancy@gmail.com">mossrockbvconsultancy@gmail.com</a>
          
          <div className="horlist">  
            <div className="block">
              <img src="images/IEC62243Consultant.png" alt="" />
              <h3>Certified IEC 62443 Consultancy Expert</h3>
            </div>
            <div className="block">
              <img src="images/grad_cap.png" alt="Mossrock B.V." />
              <h3>TU Delft Msc. Computer Science</h3>
            </div>
            <div className="block">
              <img src="images/grad_cap.png" alt="Mossrock B.V." />
              <h3>VWO Cum Laude</h3>
            </div>
          </div>
          <div className="bottom">
            <div className="horlist">
              <div className="block">
                <p>Mossrock B.V.</p>
              </div>
              <div className="block">
                <p>KVK Nr.: 91201217</p>
              </div>
              <div className="block">
                <p>VAT Nr.: NL865579969B01</p>
              </div>
              <div className="block">
                <a className="terms" href="Mossrock B.V. Algemene voorwaarden.pdf">Terms & Conditions</a>
              </div>
              <div className="block">
                <p>2026 All Right Reserved</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </section>
    
  );
}

export default Contact;